module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// D:/xampp_bk/htdocs/xampp/organicshop/~/babel-runtime/core-js/object/assign.js
// module id = ../../../../babel-runtime/core-js/object/assign.js
// module chunks = 3